/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// console.log("Hello World! (from ultime-blocks-sql-join-visualizer block)");
/* eslint-enable no-console */


(function () {
    const datasets = {
        customersOrders: {
            leftName: "clients", rightName: "commandes",
            leftKey: "id", rightKey: "customer_id",
            leftRows: [
                { id: 1, customer_name: "Alice" },
                { id: 2, customer_name: "Bob" },
                { id: 3, customer_name: "Charlie" },
                { id: 4, customer_name: "Diana" }
            ],
            rightRows: [
                { order_id: 101, customer_id: 1, amount: 120 },
                { order_id: 102, customer_id: 1, amount: 75 },
                { order_id: 103, customer_id: 2, amount: 210 },
                { order_id: 104, customer_id: 5, amount: 99 }
            ]
        },
        employeesDepartments: {
            leftName: "employes", rightName: "departements",
            leftKey: "department_id", rightKey: "id",
            leftRows: [
                { employee_id: 1, employee_name: "Emma", department_id: 10 },
                { employee_id: 2, employee_name: "Liam", department_id: 20 },
                { employee_id: 3, employee_name: "Noah", department_id: 30 },
                { employee_id: 4, employee_name: "Olivia", department_id: 99 }
            ],
            rightRows: [
                { id: 10, department_name: "Ventes" },
                { id: 20, department_name: "Marketing" },
                { id: 40, department_name: "Finance" }
            ]
        }
    };

    function init() {
        const joinTypeEl = document.getElementById("jvJoinType");
        const datasetEl = document.getElementById("jvDataset");

        if (!joinTypeEl || !datasetEl) return; // bloc absent de la page

        const reloadBtn = document.getElementById("jvReloadBtn");
        const swapBtn = document.getElementById("jvSwapBtn");
        const tableAWrap = document.getElementById("jvTableAWrap");
        const tableBWrap = document.getElementById("jvTableBWrap");
        const resultWrap = document.getElementById("jvResultWrap");
        const resultMeta = document.getElementById("jvResultMeta");
        const pairsWrap = document.getElementById("jvPairsWrap");
        const sqlCode = document.getElementById("jvSqlCode");
        const joinExpl = document.getElementById("jvJoinExplanation");
        const tableATitle = document.getElementById("jvTableATitle");
        const tableBTitle = document.getElementById("jvTableBTitle");
        const sectionTables = document.getElementById("sectionTables");
        const panelTableA = document.getElementById("panelTableA");
        const panelTableB = document.getElementById("panelTableB");
        const panelSqlResult = document.getElementById("panelSqlResult");
        const panelPairs = document.getElementById("panelPairs");
        const blockSql = document.getElementById("blockSql");
        const blockResult = document.getElementById("blockResult");
        const sqlResultDivider = document.getElementById("sqlResultDivider");
        const toggleTableA = document.getElementById("toggleTableA");
        const toggleTableB = document.getElementById("toggleTableB");
        const toggleResult = document.getElementById("toggleResult");
        const togglePairs = document.getElementById("togglePairs");
        const toggleSql = document.getElementById("toggleSql");
        const vennOnlyLeft = document.getElementById("jvOnlyLeft");
        const vennOnlyRight = document.getElementById("jvOnlyRight");
        const vennOverlap = document.getElementById("jvOverlap");
        const vennLabelL1 = document.getElementById("jvVennLabelL1");
        const vennLabelL2 = document.getElementById("jvVennLabelL2");
        const labelA = document.getElementById("jvLabelA");
        const labelB = document.getElementById("jvLabelB");

        let swapped = false;

        function setVennLabel(text) {
            const words = text.split(" ");
            const mid = Math.ceil(words.length / 2);
            vennLabelL1.textContent = words.slice(0, mid).join(" ");
            vennLabelL2.textContent = words.slice(mid).join(" ");
        }

        function getCurrentData() {
            const data = datasets[datasetEl.value];
            if (!swapped) return { ...data };
            return {
                leftName: data.rightName, rightName: data.leftName,
                leftKey: data.rightKey, rightKey: data.leftKey,
                leftRows: data.rightRows, rightRows: data.leftRows
            };
        }

        function getColumns(rows) {
            const cols = new Set();
            rows.forEach(row => Object.keys(row).forEach(k => cols.add(k)));
            return [...cols];
        }

        function escapeHtml(v) {
            return String(v ?? "")
                .replace(/&/g, "&amp;").replace(/</g, "&lt;")
                .replace(/>/g, "&gt;").replace(/"/g, "&quot;");
        }

        function resetVenn() {
            vennOnlyLeft.setAttribute("class", "jv-only-left");
            vennOnlyRight.setAttribute("class", "jv-only-right");
            vennOverlap.setAttribute("class", "jv-overlap");
        }

        function activateKeep(el) {
            el.setAttribute("class", el.getAttribute("class") + " jv-active-keep");
        }

        const vennConfig = {
            INNER: ["overlap", "INNER JOIN ne conserve que l'intersection."],
            LEFT: ["left+overlap", "LEFT JOIN conserve toutes les lignes de A, y compris l'intersection."],
            RIGHT: ["right+overlap", "RIGHT JOIN conserve toutes les lignes de B, y compris l'intersection."],
            FULL: ["left+right+overlap", "FULL OUTER JOIN conserve les deux cercles entiers."],
            LEFT_ONLY: ["left", "LEFT EXCLUDING JOIN : lignes de A sans correspondance dans B."],
            RIGHT_ONLY: ["right", "RIGHT EXCLUDING JOIN : lignes de B sans correspondance dans A."],
            OUTER_EXCL: ["left+right", "OUTER EXCLUDING JOIN : lignes sans correspondance des deux côtés."],
            SEMI: ["overlap", "SEMI JOIN conserve les lignes de A ayant une correspondance dans B."],
            ANTI: ["left", "ANTI JOIN : lignes de A sans aucune correspondance dans B."]
        };

        function updateVenn(joinType) {
            resetVenn();
            const [zones, label] = vennConfig[joinType] || ["", ""];
            if (zones.includes("left")) activateKeep(vennOnlyLeft);
            if (zones.includes("right")) activateKeep(vennOnlyRight);
            if (zones.includes("overlap")) activateKeep(vennOverlap);
            setVennLabel(label);
        }

        function renderTable(container, rows, { matchedIndexes = new Set(), unmatchedIndexes = new Set() } = {}) {
            if (!rows.length) {
                container.innerHTML = '<div class="jv-empty">Aucune ligne disponible.</div>';
                return;
            }
            const columns = getColumns(rows);
            let html = "<table><thead><tr>" + columns.map(c => "<th>" + escapeHtml(c) + "</th>").join("") + "</tr></thead><tbody>";
            rows.forEach((row, i) => {
                const cls = matchedIndexes.has(i) ? "jv-match" : unmatchedIndexes.has(i) ? "jv-no-match" : "";
                html += `<tr class="${cls}">` + columns.map(c => "<td>" + escapeHtml(row[c] ?? "NULL") + "</td>").join("") + "</tr>";
            });
            html += "</tbody></table>";
            container.innerHTML = html;
        }

        function computeJoin(data, joinType) {
            const { leftRows, rightRows, leftKey, rightKey } = data;
            const leftHasMatch = new Set(), rightHasMatch = new Set();
            const pairs = [], result = [];
            const leftColumns = getColumns(leftRows), rightColumns = getColumns(rightRows);

            leftRows.forEach((lr, li) => {
                rightRows.forEach((rr, ri) => {
                    if (lr[leftKey] === rr[rightKey]) {
                        leftHasMatch.add(li);
                        rightHasMatch.add(ri);
                        pairs.push({ leftRow: lr, rightRow: rr });
                        if (["INNER", "LEFT", "RIGHT", "FULL"].includes(joinType)) {
                            const row = {};
                            leftColumns.forEach(c => row["A." + c] = lr[c] ?? null);
                            rightColumns.forEach(c => row["B." + c] = rr[c] ?? null);
                            result.push(row);
                        }
                    }
                });
            });

            if (["LEFT", "FULL"].includes(joinType)) {
                leftRows.forEach((lr, li) => {
                    if (!leftHasMatch.has(li)) {
                        const row = {};
                        leftColumns.forEach(c => row["A." + c] = lr[c] ?? null);
                        rightColumns.forEach(c => row["B." + c] = null);
                        result.push(row);
                    }
                });
            }

            if (["RIGHT", "FULL"].includes(joinType)) {
                rightRows.forEach((rr, ri) => {
                    if (!rightHasMatch.has(ri)) {
                        const row = {};
                        leftColumns.forEach(c => row["A." + c] = null);
                        rightColumns.forEach(c => row["B." + c] = rr[c] ?? null);
                        result.push(row);
                    }
                });
            }

            if (["LEFT_ONLY", "ANTI"].includes(joinType)) {
                leftRows.forEach((lr, li) => {
                    if (!leftHasMatch.has(li)) {
                        const row = {};
                        leftColumns.forEach(c => row[c] = lr[c] ?? null);
                        result.push(row);
                    }
                });
            }

            if (joinType === "RIGHT_ONLY") {
                rightRows.forEach((rr, ri) => {
                    if (!rightHasMatch.has(ri)) {
                        const row = {};
                        rightColumns.forEach(c => row[c] = rr[c] ?? null);
                        result.push(row);
                    }
                });
            }

            if (joinType === "SEMI") {
                leftRows.forEach((lr, li) => {
                    if (leftHasMatch.has(li)) {
                        const row = {};
                        leftColumns.forEach(c => row[c] = lr[c] ?? null);
                        result.push(row);
                    }
                });
            }

            if (joinType === "OUTER_EXCL") {
                leftRows.forEach((lr, li) => {
                    if (!leftHasMatch.has(li)) {
                        const row = {};
                        leftColumns.forEach(c => row["A." + c] = lr[c] ?? null);
                        rightColumns.forEach(c => row["B." + c] = null);
                        result.push(row);
                    }
                });
                rightRows.forEach((rr, ri) => {
                    if (!rightHasMatch.has(ri)) {
                        const row = {};
                        leftColumns.forEach(c => row["A." + c] = null);
                        rightColumns.forEach(c => row["B." + c] = rr[c] ?? null);
                        result.push(row);
                    }
                });
            }

            const allLeft = new Set(leftRows.map((_, i) => i));
            const allRight = new Set(rightRows.map((_, i) => i));

            const keptLeft = {
                INNER: new Set(leftHasMatch),
                LEFT: allLeft,
                RIGHT: new Set(leftHasMatch),
                FULL: allLeft,
                LEFT_ONLY: new Set([...allLeft].filter(i => !leftHasMatch.has(i))),
                ANTI: new Set([...allLeft].filter(i => !leftHasMatch.has(i))),
                RIGHT_ONLY: new Set(),
                SEMI: new Set(leftHasMatch),
                OUTER_EXCL: new Set([...allLeft].filter(i => !leftHasMatch.has(i)))
            }[joinType] || new Set();

            const keptRight = {
                INNER: new Set(rightHasMatch),
                LEFT: new Set(rightHasMatch),
                RIGHT: allRight,
                FULL: allRight,
                LEFT_ONLY: new Set(),
                ANTI: new Set(),
                RIGHT_ONLY: new Set([...allRight].filter(i => !rightHasMatch.has(i))),
                SEMI: new Set(),
                OUTER_EXCL: new Set([...allRight].filter(i => !rightHasMatch.has(i)))
            }[joinType] || new Set();

            return {
                keptLeft,
                keptRight,
                notKeptLeft: new Set([...allLeft].filter(i => !keptLeft.has(i))),
                notKeptRight: new Set([...allRight].filter(i => !keptRight.has(i))),
                pairs,
                result
            };
        }

        function renderPairs(pairs, data) {
            if (!pairs.length) {
                pairsWrap.innerHTML = '<div class="jv-empty">Aucune ligne correspondante pour ce mode.</div>';
                return;
            }
            pairsWrap.innerHTML = '<div class="jv-pairs">' + pairs.map(pair => `
                <div class="jv-pair-card">
                    <div class="jv-badge">Correspondance</div>
                    <div class="jv-pair-grid">
                        <div class="jv-mini-box"><strong>${escapeHtml(data.leftName)}</strong><pre>${escapeHtml(JSON.stringify(pair.leftRow, null, 2))}</pre></div>
                        <div class="jv-arrow">↔</div>
                        <div class="jv-mini-box"><strong>${escapeHtml(data.rightName)}</strong><pre>${escapeHtml(JSON.stringify(pair.rightRow, null, 2))}</pre></div>
                    </div>
                </div>`).join("") + "</div>";
        }

        const sqlTemplates = {
            INNER: d => `SELECT *\nFROM ${d.l}\nINNER JOIN ${d.r}\n  ON ${d.l}.${d.lk} = ${d.r}.${d.rk};`,
            LEFT: d => `SELECT *\nFROM ${d.l}\nLEFT JOIN ${d.r}\n  ON ${d.l}.${d.lk} = ${d.r}.${d.rk};`,
            RIGHT: d => `SELECT *\nFROM ${d.l}\nRIGHT JOIN ${d.r}\n  ON ${d.l}.${d.lk} = ${d.r}.${d.rk};`,
            FULL: d => `SELECT *\nFROM ${d.l}\nFULL OUTER JOIN ${d.r}\n  ON ${d.l}.${d.lk} = ${d.r}.${d.rk};`,
            LEFT_ONLY: d => `SELECT ${d.l}.*\nFROM ${d.l}\nLEFT JOIN ${d.r}\n  ON ${d.l}.${d.lk} = ${d.r}.${d.rk}\nWHERE ${d.r}.${d.rk} IS NULL;`,
            RIGHT_ONLY: d => `SELECT ${d.r}.*\nFROM ${d.l}\nRIGHT JOIN ${d.r}\n  ON ${d.l}.${d.lk} = ${d.r}.${d.rk}\nWHERE ${d.l}.${d.lk} IS NULL;`,
            OUTER_EXCL: d => `SELECT *\nFROM ${d.l}\nFULL OUTER JOIN ${d.r}\n  ON ${d.l}.${d.lk} = ${d.r}.${d.rk}\nWHERE ${d.l}.${d.lk} IS NULL\n   OR ${d.r}.${d.rk} IS NULL;`,
            SEMI: d => `SELECT *\nFROM ${d.l}\nWHERE EXISTS (\n  SELECT 1 FROM ${d.r}\n  WHERE ${d.l}.${d.lk} = ${d.r}.${d.rk}\n);`,
            ANTI: d => `SELECT *\nFROM ${d.l}\nWHERE NOT EXISTS (\n  SELECT 1 FROM ${d.r}\n  WHERE ${d.l}.${d.lk} = ${d.r}.${d.rk}\n);`
        };

        const explTemplates = {
            INNER: (l, r) => `Retourne uniquement les lignes où ${l} et ${r} correspondent.`,
            LEFT: (l, r) => `Retourne toutes les lignes de ${l}, ainsi que les lignes correspondantes de ${r}.`,
            RIGHT: (l, r) => `Retourne toutes les lignes de ${r}, ainsi que les lignes correspondantes de ${l}.`,
            FULL: (l, r) => `Retourne toutes les lignes de ${l} et de ${r}, avec correspondance lorsque possible.`,
            LEFT_ONLY: (l, r) => `Retourne les lignes de ${l} qui n'ont aucune correspondance dans ${r}.`,
            RIGHT_ONLY: (l, r) => `Retourne les lignes de ${r} qui n'ont aucune correspondance dans ${l}.`,
            OUTER_EXCL: (l, r) => `Retourne les lignes de ${l} et de ${r} qui n'ont aucune correspondance dans l'autre table (exclut l'intersection).`,
            SEMI: (l, r) => `Retourne les lignes de ${l} ayant au moins une correspondance dans ${r}, sans retourner les colonnes de ${r}.`,
            ANTI: (l, r) => `Retourne les lignes de ${l} qui n'ont aucune correspondance dans ${r}.`
        };

        function updateVisibility() {
            panelTableA.classList.toggle("jv-hidden", !toggleTableA.checked);
            panelTableB.classList.toggle("jv-hidden", !toggleTableB.checked);
            sectionTables.classList.toggle("jv-hidden", !toggleTableA.checked && !toggleTableB.checked);
            blockSql.classList.toggle("jv-hidden", !toggleSql.checked);
            blockResult.classList.toggle("jv-hidden", !toggleResult.checked);
            sqlResultDivider.classList.toggle("jv-hidden", !toggleSql.checked || !toggleResult.checked);
            panelSqlResult.classList.toggle("jv-hidden", !toggleSql.checked && !toggleResult.checked);
            panelPairs.classList.toggle("jv-hidden", !togglePairs.checked);
        }

        function renderAll() {
            const joinType = joinTypeEl.value;
            const data = getCurrentData();
            const computed = computeJoin(data, joinType);

            labelA.textContent = data.leftName;
            labelB.textContent = data.rightName;
            tableATitle.textContent = "Table A — " + data.leftName;
            tableBTitle.textContent = "Table B — " + data.rightName;

            renderTable(tableAWrap, data.leftRows, { matchedIndexes: computed.keptLeft, unmatchedIndexes: computed.notKeptLeft });
            renderTable(tableBWrap, data.rightRows, { matchedIndexes: computed.keptRight, unmatchedIndexes: computed.notKeptRight });
            renderTable(resultWrap, computed.result);
            renderPairs(computed.pairs, data);
            updateVenn(joinType);

            const d = { l: data.leftName, r: data.rightName, lk: data.leftKey, rk: data.rightKey };
            sqlCode.textContent = (sqlTemplates[joinType] || (() => ""))(d);
            joinExpl.textContent = (explTemplates[joinType] || (() => ""))(data.leftName, data.rightName);
            resultMeta.textContent = `${joinType.replaceAll("_", " ")} sur ${data.leftName}.${data.leftKey} = ${data.rightName}.${data.rightKey} — ${computed.result.length} ligne(s) résultante(s).`;

            updateVisibility();
        }

        // Share button
        const shareBtn = document.getElementById("jvShareBtn");
        if (shareBtn) {
            shareBtn.addEventListener("click", () => {
                const url = window.location.href;
                if (navigator.share) {
                    navigator.share({
                        title: "Visualiseur de jointures SQL",
                        text: "Découvrez cet outil interactif pour comprendre les jointures SQL.",
                        url
                    }).catch(() => { });
                } else {
                    navigator.clipboard.writeText(url).then(() => {
                        const toast = document.getElementById("jvShareToast");
                        if (toast) {
                            toast.style.display = "block";
                            setTimeout(() => { toast.style.display = "none"; }, 2500);
                        }
                    }).catch(() => { prompt("Copiez ce lien :", url); });
                }
            });
        }

        // Listeners
        [toggleTableA, toggleTableB, toggleResult, togglePairs, toggleSql]
            .forEach(el => el.addEventListener("change", updateVisibility));

        joinTypeEl.addEventListener("change", renderAll);
        datasetEl.addEventListener("change", renderAll);
        reloadBtn.addEventListener("click", renderAll);
        swapBtn.addEventListener("click", () => { swapped = !swapped; renderAll(); });

        renderAll();
    }

    // Point d'entrée — gère Chrome/Edge (DOM pas encore prêt) et Firefox (DOM déjà prêt)
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }

})();